// Librerías
import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
// Componentes
// Recursos
import "../../assets/styles/FAQ/_faq.sass"
import Accordion from "../Utils/Accordion";
import SideMenu from "../Utils/SideMenu";
import {
    mostCommonQuestionsEs,
    mostCommonQuestionsEn,
    mostCommonQuestionsPo
} from "./faqComponentLang";
import useCurrentLanguage from "../../services/currentlenguaje";
import jsonFAQ from "./tradFAQ.json";


const FAQComponent = ({ lenguaje }) => {
    const [questionsType, setQuestionsType] = useState("");
    const [jsonCommonQuestions, setjsonCommonQuestions] = useState("mostCommonJsonEs");
    const { handleFilterLang } = useCurrentLanguage();

    const relatedTrustLinks = [
        {
            to: "/contacto",
            label: "Contacto",
            description: "Canales públicos para soporte general, incidencias y dudas sobre reservas."
        },
        {
            to: "/politica-de-privacidad",
            label: "Privacidad",
            description: "Información sobre datos de cuenta, cookies y derechos del usuario."
        },
        {
            to: "/terminos",
            label: "Términos",
            description: "Condiciones generales del servicio, pagos y responsabilidades."
        },
        {
            to: "/quienes-somos",
            label: "Quiénes somos",
            description: "Qué es Alohar y qué tipo de experiencia de alojamiento ofrece."
        }
    ];



    useEffect(() => {
        if (lenguaje === "es") {
            setjsonCommonQuestions(mostCommonQuestionsEs);
        }
        if (lenguaje === "en") {
            setjsonCommonQuestions(mostCommonQuestionsEn);
        }
        if (lenguaje === "po") {
            setjsonCommonQuestions(mostCommonQuestionsPo);
        }
    }, [lenguaje]);

    const [title, setTitle] = useState("");

    const questions = Array.isArray(jsonCommonQuestions)
        ? jsonCommonQuestions.filter(
            (mostCommonQuestions) => mostCommonQuestions.questionsType === questionsType
        )
        : [];

    return (
        <React.Fragment>
            <div className="FAQContainer">
                <div className='FAQContainer__sideBar'>
                    <SideMenu />
                </div>
                <div className="FAQ">
                    <h1 className="FAQ__title">
                    {handleFilterLang(jsonFAQ).centroDeAyuda}
                    </h1>
                    <div className="mb-8 rounded-[28px] bg-white p-6 shadow-[0_16px_40px_rgba(31,41,55,0.08)] md:p-8">
                        <h2 className="text-2xl font-semibold text-[#111827]">Ayuda pública antes de reservar o publicar</h2>
                        <p className="mt-4 text-base leading-7 text-[#374151]">
                            Esta página reúne respuestas frecuentes sobre registro, pagos, cancelaciones, reservas y comunicación dentro de Alohar. También funciona como punto público de orientación para que cualquier persona pueda entender cómo usar la plataforma antes de crear una cuenta.
                        </p>
                        <div className="mt-5 grid gap-4 md:grid-cols-3">
                            <div className="rounded-[20px] border border-[#e5ded0] bg-[#fffaf2] p-4">
                                <h3 className="text-lg font-semibold text-[#111827]">Reservas y pagos</h3>
                                <p className="mt-2 text-sm leading-6 text-[#4b5563]">Encontrá respuestas sobre confirmaciones, cancelaciones, cobros y seguimiento de la reserva.</p>
                            </div>
                            <div className="rounded-[20px] border border-[#e5ded0] bg-[#fffaf2] p-4">
                                <h3 className="text-lg font-semibold text-[#111827]">Cuenta y seguridad</h3>
                                <p className="mt-2 text-sm leading-6 text-[#4b5563]">Revisá temas de acceso, configuración de perfil, validación e incidencias operativas.</p>
                            </div>
                            <div className="rounded-[20px] border border-[#e5ded0] bg-[#fffaf2] p-4">
                                <h3 className="text-lg font-semibold text-[#111827]">Canales complementarios</h3>
                                <p className="mt-2 text-sm leading-6 text-[#4b5563]">Si tu caso necesita seguimiento, podés continuar con las páginas públicas de contacto, privacidad o términos.</p>
                            </div>
                        </div>
                        <div className="mt-5 grid gap-3 md:grid-cols-2 xl:grid-cols-4">
                            {relatedTrustLinks.map((item) => (
                                <Link key={item.to} to={item.to} className="rounded-2xl border border-[#d9d9d9] px-4 py-4 transition-colors hover:bg-[#f9fafb]">
                                    <p className="text-base font-medium text-[#111827]">{item.label}</p>
                                    <p className="mt-2 text-sm leading-6 text-[#4b5563]">{item.description}</p>
                                </Link>
                            ))}
                        </div>
                    </div>
                    <div className="FAQ__menu">
                        <p className={`FAQ__menu__question ${questionsType === "covid" ? "active" : ""}`} onClick={() => { setQuestionsType("covid") }}>
                            {handleFilterLang(jsonFAQ).covid}

                        </p>
                        <p className={`FAQ__menu__question ${questionsType === "register" ? "active" : ""}`} onClick={() => { setQuestionsType("register") }}>
                            {handleFilterLang(jsonFAQ).registro}

                        </p>
                        <p className={`FAQ__menu__question ${questionsType === "login" ? "active" : ""}`} onClick={() => { setQuestionsType("login") }}>
                            {handleFilterLang(jsonFAQ).inicioVerificacion}

                        </p>
                        <p className={`FAQ__menu__question ${questionsType === "password" ? "active" : ""}`} onClick={() => { setQuestionsType("password") }}>
                            {handleFilterLang(jsonFAQ).contraseña}

                        </p>
                        <p className={`FAQ__menu__question ${questionsType === "profile-configuration" ? "active" : ""}`} onClick={() => { setQuestionsType("profile-configuration") }}>
                            {handleFilterLang(jsonFAQ).configuracionPerfil}

                        </p>
                        <p className={`FAQ__menu__question ${questionsType === "housing-configuration" ? "active" : ""}`} onClick={() => { setQuestionsType("housing-configuration") }}>
                            {handleFilterLang(jsonFAQ).configuracionAlohamiento}

                        </p>
                        <p className={`FAQ__menu__question ${questionsType === "bookings" ? "active" : ""}`} onClick={() => { setQuestionsType("bookings") }}>
                            {handleFilterLang(jsonFAQ).reservas}

                        </p>
                        <p className={`FAQ__menu__question ${questionsType === "bookings-comms" ? "active" : ""}`} onClick={() => { setQuestionsType("bookings-comms") }}>
                            {handleFilterLang(jsonFAQ).comunicacionReservas}

                        </p>
                        <p className={`FAQ__menu__question ${questionsType === "cancelled" ? "active" : ""}`} onClick={() => { setQuestionsType("cancelled") }}>
                            {handleFilterLang(jsonFAQ).cancelaciones}

                        </p>
                        <p className={`FAQ__menu__question ${questionsType === "taxes" ? "active" : ""}`} onClick={() => { setQuestionsType("taxes") }}>
                            {handleFilterLang(jsonFAQ).impositivo}

                        </p>
                        <p className={`FAQ__menu__question ${questionsType === "accountabilities" ? "active" : ""}`} onClick={() => { setQuestionsType("accountabilities") }}>
                            {handleFilterLang(jsonFAQ).responsabilidades}

                        </p>
                    </div>
                    <div className="FAQ__content">
                        {
                            questions.map(e => (
                                <Accordion
                                    key={e.id}
                                    title={e.question}
                                    content={e.answer}
                                />
                            ))
                        }
                    </div>
                </div>
            </div>
            <div className="FAQMobile">
                <h1 className="FAQMobile__title">
                    <p className={`FAQMobile__title__btn${(title !== "") ? " active" : ""}`}
                        onClick={() => {
                            setTitle("")
                            setQuestionsType("")
                            window.scrollTo(0, 0)
                        }}>
                    </p>
                    <p className="FAQMobile__title__title">
                        {(questionsType !== "") ? title : "Centro de Ayuda"}
                    </p>
                </h1>
                <div className="mx-4 mb-6 rounded-[24px] bg-white p-5 shadow-[0_16px_40px_rgba(31,41,55,0.08)]">
                    <h2 className="text-xl font-semibold text-[#111827]">Qué podés resolver acá</h2>
                    <p className="mt-3 text-sm leading-6 text-[#374151]">
                        Desde esta página podés orientarte sobre reservas, pagos, cancelaciones, cuenta y uso general de Alohar. Si necesitás otro canal, también tenés contacto, privacidad y términos disponibles como páginas públicas.
                    </p>
                    <div className="mt-4 grid gap-3">
                        {relatedTrustLinks.map((item) => (
                            <Link key={item.to} to={item.to} className="rounded-2xl border border-[#d9d9d9] px-4 py-3">
                                <p className="text-sm font-medium text-[#111827]">{item.label}</p>
                                <p className="mt-1 text-sm leading-6 text-[#4b5563]">{item.description}</p>
                            </Link>
                        ))}
                    </div>
                </div>
                <div className={`FAQMobile__menu${(title !== "") ? "" : " active"}`}>
                    <p className={`FAQMobile__menu__question ${questionsType === "covid" ? "active" : ""}`} onClick={() => {
                        window.scrollTo(0, 0)
                        setTitle("COVID")
                        setQuestionsType("covid")
                    }}>
                        {handleFilterLang(jsonFAQ).covid}

                    </p>
                    <p className={`FAQMobile__menu__question ${questionsType === "register" ? "active" : ""}`} onClick={() => {
                        window.scrollTo(0, 0)
                        setTitle(handleFilterLang(jsonFAQ).registro)
                        setQuestionsType("register")
                    }}>
                        {handleFilterLang(jsonFAQ).registro}

                    </p>
                    <p className={`FAQMobile__menu__question ${questionsType === "login" ? "active" : ""}`} onClick={() => {
                        window.scrollTo(0, 0)
                        setTitle(handleFilterLang(jsonFAQ).inicioVerificacion)
                        setQuestionsType("login")
                    }}>
                        {handleFilterLang(jsonFAQ).inicioVerificacion}

                    </p>
                    <p className={`FAQMobile__menu__question ${questionsType === "password" ? "active" : ""}`} onClick={() => {
                        window.scrollTo(0, 0)
                        setTitle(handleFilterLang(jsonFAQ).contraseña)
                        setQuestionsType("password")
                    }}>
                        {handleFilterLang(jsonFAQ).contraseña}

                    </p>
                    <p className={`FAQMobile__menu__question ${questionsType === "profile-configuration" ? "active" : ""}`} onClick={() => {
                        window.scrollTo(0, 0)
                        setTitle(handleFilterLang(jsonFAQ).configuracionPerfil)
                        setQuestionsType("profile-configuration")
                    }}>
                        {handleFilterLang(jsonFAQ).configuracionPerfil}

                    </p>
                    <p className={`FAQMobile__menu__question ${questionsType === "housing-configuration" ? "active" : ""}`} onClick={() => {
                        window.scrollTo(0, 0)
                        setTitle(handleFilterLang(jsonFAQ).configuracionAlohamiento)
                        setQuestionsType("housing-configuration")
                    }}>
                        {handleFilterLang(jsonFAQ).configuracionAlohamiento}

                    </p>
                    <p className={`FAQMobile__menu__question ${questionsType === "bookings" ? "active" : ""}`} onClick={() => {
                        window.scrollTo(0, 0)
                        setTitle(handleFilterLang(jsonFAQ).reservas)
                        setQuestionsType("bookings")
                    }}>
                        {handleFilterLang(jsonFAQ).reservas}

                    </p>
                    <p className={`FAQMobile__menu__question ${questionsType === "bookings-comms" ? "active" : ""}`} onClick={() => {
                        window.scrollTo(0, 0)
                        setTitle(handleFilterLang(jsonFAQ).comunicacionReservas)
                        setQuestionsType("bookings-comms")
                    }}>
                        {handleFilterLang(jsonFAQ).comunicacionReservas}

                    </p>
                    <p className={`FAQMobile__menu__question ${questionsType === "cancelled" ? "active" : ""}`} onClick={() => {
                        window.scrollTo(0, 0)
                        setTitle(handleFilterLang(jsonFAQ).cancelaciones)
                        setQuestionsType("cancelled")
                    }}>
                        {handleFilterLang(jsonFAQ).cancelaciones}

                    </p>
                    <p className={`FAQMobile__menu__question ${questionsType === "taxes" ? "active" : ""}`} onClick={() => {
                        window.scrollTo(0, 0)
                        setTitle(handleFilterLang(jsonFAQ).impositivo)
                        setQuestionsType("taxes")
                    }}>
                        {handleFilterLang(jsonFAQ).impositivo}

                    </p>
                    <p className={`FAQMobile__menu__question ${questionsType === "accountabilities" ? "active" : ""}`} onClick={() => {
                        window.scrollTo(0, 0)
                        setTitle(handleFilterLang(jsonFAQ).responsabilidades)
                        setQuestionsType("accountabilities")
                    }}>
                        {handleFilterLang(jsonFAQ).responsabilidades}

                    </p>
                </div>
                <div className="FAQMobile__content">
                    {
                        questions.map(e => (
                            <Accordion
                                key={e.id}
                                title={e.question}
                                content={e.answer}
                            />
                        ))
                    }
                </div>
            </div>
        </React.Fragment>
    );
}

export default FAQComponent;